export const types = {
  TOGGLE_SOCIAL_WIDGET: 'TOGGLE_SOCIAL_WIDGET',
  OPEN_SOCIAL_WIDGET: 'OPEN_SOCIAL_WIDGET',
  CLOSE_SOCIAL_WIDGET: 'CLOSE_SOCIAL_WIDGET',
  SET_SOCIAL_WIDGET_PROPS: 'SET_SOCIAL_WIDGET_PROPS',
};

export const actions = {
  toggleSocialWidget: () => ({
    type: types.TOGGLE_SOCIAL_WIDGET,
  }),
  openSocialWidget: () => ({
    type: types.OPEN_SOCIAL_WIDGET,
  }),
  closeSocialWidget: () => ({
    type: types.CLOSE_SOCIAL_WIDGET,
  }),
  setSocialWidgetProps: payload => ({
    type: types.SET_SOCIAL_WIDGET_PROPS,
    payload,
  }),
};

const INITIAL_STATE = {
  isSocialWidgetOpen: false,
};

/*eslint-disable complexity */
const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.TOGGLE_SOCIAL_WIDGET:
      return {
        ...state,
        isSocialWidgetOpen: !state.isSocialWidgetOpen,
      };
    case types.OPEN_SOCIAL_WIDGET:
      return {
        ...state,
        isSocialWidgetOpen: true,
      };
    case types.CLOSE_SOCIAL_WIDGET:
      return {
        ...state,
        isSocialWidgetOpen: false,
      };
    case types.SET_SOCIAL_WIDGET_PROPS:
      return {
        ...state,
        socialWidgetProps: {
          ...state.socialWidgetProps,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;

export const getIsSocialWidgetOpen = state =>
  state.socialWidget.isSocialWidgetOpen;

export const getSocialWidget = state => state.socialWidget;



// WEBPACK FOOTER //
// ./app/redux/socialWidget.js